<template>
    <div class="supplementBox">
            <div class="supplement">
                <h4>证据材料</h4>
                <p style="border: 1px solid #3b63f6"></p>
            </div>
            <div class="contractNameBox">
                <div class="contractName">
                    <p>合同名称:</p>
                    <el-input v-model="contractName.doc_title" disabled placeholder="请输入合同名称"></el-input>
                </div>
                <div class="contractType">
                    <p>合同类型:</p>
                    <el-input v-model="contractName.product_name" disabled placeholder="请输入合同类型"></el-input>
                </div>
                <div class="contractType">
                    <p>被申请人:</p>
                    <el-input v-model="contractName.signers_txt" disabled placeholder="请输入被申请人"></el-input>
                </div>
            </div>
            <div class="evidenceBox" v-for="(item,index) in product_list" :key="index">
<!--                <div class="evidence">-->
<!--                    <p>{{item.name}}</p>-->
<!--                </div>-->
                <fieldset class="proofBox">
                    <legend>{{item.name}}</legend>
                    <div class="matter" v-for="(i,z) in item.children" :key="z">
                        <el-form >
                            <el-form-item style="flex-shrink:0" :label="i.name" class="titleBox" :rules="[{ required: i.is_bitian}]">
                            </el-form-item>
                        <!--                    <el-form >-->
                        <!--                    <el-form-item label="信用卡申请表(卡分期专用)" class="inline-2"  v-for="(item,index) in 2" :key="index">-->
                        <!--                        <el-input v-model="filename" class="input-320" placeholder="仅支持.jpg、.png、.pdf文件" :disabled="edit"></el-input>-->
                        <el-upload
                                class="inline"
                                :limit="10"
                                :on-preview="handlePreview"
                                :on-remove="(file, fileList) => {handleRemove(file, fileList, i.id)}"
                                :on-success="handleSuccess"
                                :on-exceed="handleExceed"
                                accept=".pdf,.jpg,.png,.zip,.rar"
                                :headers="headers"
                                :action="url"
                                name="file"
                                :data="upload_data"
                                :file-list="i.file_list"
                                :on-progress="onProgress"
                        >

                            <el-button class="custom" @click="submitUpload(i.id)">
                                上传
                            </el-button>
                            <!--                            <el-button type="primary" style="margin-left: 5px" size="mini" title="上传文件"><i class="iconfont iconwenjian"></i></el-button>-->
                        </el-upload>
                        <!--                        <el-button  class="View" @click="View">查看</el-button>-->
                        <!--                    </el-form-item>-->
                        <!--                    </el-form>-->
                        </el-form>
                    </div>

                    <!--                    查看弹框-->
                    <el-dialog
                            title="提示"
                            :visible.sync="dialogVisible"
                            width="30%"
                            :before-close="handleClose">
                        <p>{{filename}}</p>
                        <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
                </fieldset>

            </div>
            <div class="save" style="margin: auto;">
                <el-button  class="save" @click="preserve">保存证据</el-button>
            </div>

    </div>
</template>

<script>
    import { adminicleDetails, evidencePreserve, uploadFile } from '../../../api/evidence';

    export default {
        name: 'testimony',
        data(){
            return{
                url:process.env.VUE_APP_BASE_API+'/api/upload_zhcai_evidence_file',
                headers:{
                    "Authorization": sessionStorage.getItem("token"),
                    "Comid": sessionStorage.getItem("shenfen"),
                    "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn

                },
                dialogVisible: false,
                edit:true,
                fileData:[],
                newArr: [],
                designation:'', //合同名称
                genre:'', //合同类型
                filename:'',
                fileList:'',
                evidenceList:[],
                contractName:'',
                product_list:[],
                listName:[],
                id:"",
                case_status:'',
                upload_data:{
                    case_id:'',
                    evidence_id:''
                },
                case_id:'',
                psd_codes_arr:[],
                psd_code:"",
                evidence_datas:[],
            }
        },
        methods: {
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            //上传
            handleChange( file,fileList) {
                uploadFile(this.upload_data.case_id,this.upload_data.evidence_id,file.raw).then(res=>{
                })
            },
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();;
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();;
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            //移除事件
            handleRemove(file, fileList,i){
                this.product_list.forEach((item,index)=>{
                    item.children.forEach((itm,idx)=>{
                        if(itm.id == i){
                            const psd_arr = [];
                            itm.file_list.forEach((it,ix)=>{
                                if(it.psd_code == file.psd_code){
                                    itm.file_list.splice(ix,1)
                                }
                            })
                            if(itm.file_list.length > 0){
                                itm.file_list.forEach((par,is)=>{
                                    psd_arr.push(par.psd_code)
                                })
                            }
                            let is_cunzai = false;
                            if(this.evidence_datas.length > 0){
                                this.evidence_datas.forEach((param,i)=>{
                                    if(param.evidence_id == i){
                                        is_cunzai = true;
                                        param.psd_codes = psd_arr;
                                    }
                                })
                            }
                            if(!is_cunzai){
                                this.evidence_datas.push({
                                    evidence_id:i,
                                    psd_codes:psd_arr
                                })
                            }
                        }
                    })
                })

            },
            //上传成功
            handleSuccess(response, file, fileList){
                if(response.code == 200){
                    this.product_list.forEach((item,index)=>{
                        item.children.forEach((itm,idx)=>{
                            const obj = {
                                name:response.data.file_name,
                                file_name:response.data.file_name,
                                file_url:response.data.file_url,
                                psd_code:response.data.psd_code,
                                all_url:response.data.all_url,
                            };
                            if(itm.file_list && itm.id == this.upload_data.evidence_id){
                                itm.file_list.push(obj)
                                const psd_arr = [];
                                itm.file_list.forEach((par,is)=>{
                                    psd_arr.push(par.psd_code)
                                })
                                let is_cunzai = false;
                                if(this.evidence_datas.length > 0){
                                    this.evidence_datas.forEach((param,i)=>{
                                        if(param.evidence_id == this.upload_data.evidence_id){
                                            is_cunzai = true;
                                            param.psd_codes = psd_arr;
                                        }
                                    })
                                }
                                if(!is_cunzai){
                                    this.evidence_datas.push({
                                        evidence_id:this.upload_data.evidence_id,
                                        psd_codes:psd_arr
                                    })
                                }

                            }else if(!itm.file_list && itm.id == this.upload_data.evidence_id){
                                itm.file_list = [obj]
                                const psd_arr = [];
                                itm.file_list.forEach((par,is)=>{
                                    psd_arr.push(par.psd_code)
                                })
                                let is_cunzai = false;
                                if(this.evidence_datas.length > 0){
                                    this.evidence_datas.forEach((param,i)=>{
                                        if(param.evidence_id == this.upload_data.evidence_id){
                                            is_cunzai = true;
                                            param.psd_codes = psd_arr;
                                        }
                                    })
                                }
                                if(!is_cunzai){
                                    this.evidence_datas.push({
                                        evidence_id:this.upload_data.evidence_id,
                                        psd_codes:psd_arr
                                    })
                                }

                            }
                        })
                    })
                }else{
                    fileList.forEach(function(item,index){
                        if(file.uid == item.uid){
                            fileList.splice(index,1)
                        }
                    })
                    this.$message({
                        message: response.msg,
                        type: 'error'
                    })
                }


            },
            //限制条数
            handleExceed(files, fileList){
                if (fileList.length>=10){
                    this.$message.error('只能上传10个文件');
                }
            },
            submitUpload(i){
                this.upload_data.case_id=this.id
                this.upload_data.evidence_id=i
            },
            //保存
            preserve(){
                evidencePreserve(this.case_id,this.evidence_datas).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        setTimeout(()=>{
                            this.$router.push('/lawCase')
                        },1000)
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            // 去详情页
            detailsPage(){
                this.$router.push({path:'/particulars',query:{id:this.id,case_status:this.case_status}})
            },
            // //查看
            // View(){
            //     if (this.filename==''){
            //         this.$message.error('您没有上传文件，请上传文件后再来查看');
            //     }else {
            //         this.dialogVisible=true
            //     }
            //
            // }
            //上传文件进度未上传完成时添加loading
            onProgress({ percent }) {
                if (percent!==100){
                     this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                }else {
                    this.$loading().close()
                }
            }
        },
        created() {
            this.headers.Comid=JSON.parse(sessionStorage.getItem("shenfen")).com_id
            this.id=this.$route.query.id
            this.case_status=this.$route.query.case_status
            adminicleDetails(this.$route.query.id).then(res=>{
                if (res.code==200){
                    this.case_id=res.data.id
                    this.contractName=res.data
                    this.product_list=res.data.product_list
                }else {
                    this.$message.error(res.msg)
                }

                // this.listName=res.data.product_list

            })
        }
    };
</script>

<style scoped>
    .supplementBox{
        padding: 30px;
        min-width: 95% !important;
        width: max-content;
        background-color: #fff;
    }
    .supplement>h4{
        width: 80px;
        color: #3e60f5;
        text-align: center;
        margin-bottom: 8px;
    }
    .supplement>p{
        width: 80px;
    }
    .contractNameBox{
        display: flex;
        margin: 20px 0px;
        font-size: 14px;
    }
    .contractNameBox>div{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
    }
    .contractNameBox p{
        width: 120px;
        color: #666666;
    }
    .particulars{
        background-color: #3b63f6;
        color: #fff;
    }
    .evidence{
        margin-top: 30px;
        border: 1px solid #3b63f6;
        width: 150px;
        text-align: center;
        border-radius: 5px;
    }
    .evidence>p{
        padding: 10px;
        color: #3b63f6;
    }
    /*    证据*/
    .proofBox{
        background-color: #fff;
        padding: 10px 30px;
        margin: 10px 0px;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
    }
    ::v-deep .el-form-item__content{
        display: flex;
    }
    ::v-deep .el-form{
        align-items: center;
    }
    ::v-deep .el-form-item--small{
        margin-bottom: 0;
    }
    ::v-deep .el-input--small,
    ::v-deep .el-input__inner{
        width: 250px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
    }
    ::v-deep .el-upload--text{
        width: 60px;
        height: 100%;
        border: 0px;
        /*background-color: #3b63f6;*/
        color: #fff;
    }
    .View{
        border-radius: 6px;
        width: 60px;
        height: 33px;
        background-color: #3b63f6;
        color: #fff;
    }
    .save{
        width: 120px;
        background-color: #3b63f6;
        color: #fff;
        height: 40px;
        border-radius: 5px;
    }
    ::v-deep .el-upload-list{
        /*width: 150px;*/
        display: flex;
        align-items: flex-end;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 10px 0px;
    }
    /*上传按钮*/
    .custom{
        background-color: #3b63f6;
        color: #fff;

    }
    ::v-deep .el-upload-list__item-name{
        width: 150px;
    }
    ::v-deep .el-input__inner{
        color: #878889 !important;
    }
    ::v-deep .el-upload-list--text{
        margin-right: 30px;
    }
    .titleBox{
        min-width: 15%;
        max-width: 15%;
        color: #666666;
        font-size: 14px;
    }
    legend{
        color: #666666;
        padding: 0px 10px;
        font-size: 20px;
    }
    ::v-deep .el-form{
        display: flex;
        width: 100%;
    }
</style>
